import { createFileRoute, Link } from '@tanstack/react-router'
import { CardFormSkeleton } from '@/components/skeletons'

export const Route = createFileRoute('/unsubscribe')({
  head: () => ({
    meta: [
      { title: 'Cancelar inscrição — Seu Bolso Tranquilo' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
  component: UnsubscribePage,
  pendingComponent: () => <CardFormSkeleton fields={0} />,
})

// Unsubscribe is now handled by the link in the footer of every e-mail we send.
// This page remains for links in older e-mails and points people to the right place.
function UnsubscribePage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-3xl bg-gradient-card border border-border/40 p-8 text-center space-y-4 shadow-glow">
        <h1 className="font-display text-2xl font-bold">Cancelar inscrição</h1>
        <p className="text-muted-foreground">
          Este link foi atualizado. Para parar de receber e-mails do Seu Bolso Tranquilo, use o
          link "cancelar inscrição" no rodapé do e-mail mais recente que você recebeu.
        </p>
        <p className="text-muted-foreground text-sm">
          Você também pode ajustar quais resumos e lembretes deseja receber nas configurações da
          sua conta.
        </p>
        <Link
          to="/assinatura"
          className="inline-block w-full py-3 rounded-2xl bg-gradient-primary text-primary-foreground font-semibold shadow-glow"
        >
          Ir para as preferências
        </Link>
      </div>
    </div>
  )
}
